import { Flex, FlexProps } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";
import styled from "styled-components";

type InternalMessageContainerProps = {
  position?: "static" | "absolute";
} & Omit<FlexProps, "position">;

export const FormContainer = styled(Flex)`
  /* Positioning */
  width: 100%;

  /* Styling */
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: 18px;

  /* Spacing */
  padding: 18px 18px 0px 18px; /* Moved 18px pb to mb for scrolling purposes */

  /* Layout */
  flex-direction: column;
  gap: 12px;
`;

const FormContainerAbsolute = styled(Flex)`
  /* Positioning */
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;

  /* Styling */
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;

  /* Spacing */
  padding: 18px 24px 18px 24px;
  margin: 0 0px 0px 0px;

  /* Layout */
  flex-direction: column;
  gap: 12px;
`;

export const InternalMessageContainer: FCWC<InternalMessageContainerProps> = ({
  position,
  children,
  ...props
}) => {
  switch (position) {
    case "static":
      return (
        <Flex position="relative" {...props}>
          <FormContainer>{children}</FormContainer>
        </Flex>
      );

    case "absolute":
    case undefined:
      return (
        <Flex height="76px" position="relative" {...props}>
          <FormContainerAbsolute>{children}</FormContainerAbsolute>
        </Flex>
      );
  }
};
